<template>
  <div v-if="log" class="asta-log" :class="effect">
    <v-icon :x-small="xSmall" :small="small" :color="color">{{ icon }}</v-icon>
    <div v-html="testo" class="ml-1"></div>
  </div>
</template>


<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";
import Vuex from "vuex";

export default {
  name: "asta-log",
  mixins: [mixins],
  components: {},
  props: {
    log: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    hasEffect: {
      type: Boolean,
    },
    xSmall: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
  },
  data() {
    return {
      icon: "",
      color: "",
      testo: "",
    };
  },
  mounted() {},
  destroyed() {},
  watch: {
    log: {
      handler() {
        this.set();
      },
      immediate: true,
    },
  },
  methods: {
    uiVars() {
      let ui = {};
      ui.nomeCalciatore = "-";
      ui.nomeClub = "-";
      let calciatore = this.calciatori[this.log.calciatore_id];
      if (calciatore) {
        ui.nomeCalciatore = "<strong>" + calciatore.calciatore + "</strong>";
        if (calciatore.nomeClub) {
          ui.nomeClub = calciatore.nomeClub.slice(0, 3).toUpperCase();
        }
      }
      ui.nomeSquadra = "-";
      let squadra = this.asta_squadre[this.log.squadra_id];
      if (squadra) {
        ui.nomeSquadra = "<strong>" + squadra.name + "</strong>";
      }

      ui.prezzo = "-";
      if (this.log.prezzo) {
        ui.prezzo = this.log.prezzo;
      }

      ui.prezzoOld = "-";
      if (this.log.prezzoOld) {
        ui.prezzoOld = this.log.prezzoOld;
      }

      ui.crediti = "-";
      if (this.log.crediti) {
        ui.crediti = this.log.crediti;
      }

      ui.creditiOld = "-";
      if (this.log.creditiOld) {
        ui.creditiOld = this.log.creditiOld;
      }

      ui.creditiExtra = "-";
      if (this.log.creditiExtra) {
        ui.creditiExtra = this.log.creditiExtra;
      }

      return ui;
    },
    set() {
      let ui = this.uiVars();
      switch (this.log.type) {
        case Constants.LOG_TYPE.ASSIGN:
          this.icon = "done";
          this.color = "secondary";
          this.testo =
            ui.nomeCalciatore +
            " (" +
            ui.prezzo +
            ") assegnato a " +
            ui.nomeSquadra;
          break;
        case Constants.LOG_TYPE.EDIT:
          this.icon = "edit";
          this.color = "text";
          this.testo =
            "Modificato prezzo " +
            ui.nomeCalciatore +
            " (da " +
            ui.prezzoOld +
            " a " +
            ui.prezzo +
            ") a " +
            ui.nomeSquadra;
          break;
        case Constants.LOG_TYPE.SCARTATO:
          this.icon = "delete";
          this.color = "grey lighten-3";
          this.testo = ui.nomeCalciatore + " scartato";
          break;
        case Constants.LOG_TYPE.REMOVE_SCARTATO:
          this.icon = "restore_from_trash";
          this.color = "grey lighten-3";
          this.testo = ui.nomeCalciatore + " riabilitato";
          break;
        case Constants.LOG_TYPE.REMOVE_SCARTATI:
          this.icon = "restore_from_trash";
          this.color = "grey lighten-3";
          this.testo = "Riabilitati tutti gli scartati";
          break;
        case Constants.LOG_TYPE.REMOVE:
          this.icon = "remove";
          this.color = "red";
          this.testo =
            "Annullata assegnazione " +
            ui.nomeCalciatore +
            " (" +
            ui.prezzo +
            ") a " +
            ui.nomeSquadra;
          break;
        // case Constants.LOG_TYPE.CREDITI_SQUADRA:
        //   this.icon = "edit";
        //   this.color = "red";
        //   this.testo =
        //     ui.nomeCalciatore +
        //     "Modificati crediti squadra " +
        //     ui.nomeSquadra +
        //     ": da " +
        //     ui.prezzoOld +
        //     " a " +
        //     ui.prezzo;
        //   break;
        case Constants.LOG_TYPE.EDIT_CREDITI_EXTRA:
          this.icon = "edit";
          this.color = "text";
          this.testo =
            "Crediti " +
            ui.nomeSquadra +
            " da " +
            ui.creditiOld +
            " a " +
            ui.crediti;
          break;
        case Constants.LOG_TYPE.PASSO_FORZATO:
          this.icon = "airline_stops";
          this.color = "grey lighten-3";
          this.testo = "L'admin ha forzato Passo per " + ui.nomeSquadra;
          break;
        // round
        case Constants.LOG_TYPE.CALCIATORE_IN_ASTA:
          this.icon = "person";
          this.color = "grey lighten-2";
          this.testo =
            ui.nomeCalciatore + " messo all'asta da " + ui.nomeSquadra;
          break;
        case Constants.LOG_TYPE.ROUND_START:
          this.icon = "play_arrow";
          this.color = "grey lighten-3";
          this.testo =
            "<span class='navy--text text--lighten-3'>Asta avviata</span>";
          break;
        case Constants.LOG_TYPE.ROUND_PAUSE:
          this.icon = "pause";
          this.color = "grey lighten-3";
          this.testo = "<span class='navy--text text--lighten-3'>Pausa</span>";
          break;
        case Constants.LOG_TYPE.ROUND_STOP:
          this.icon = "stop";
          this.color = "grey lighten-3";
          this.testo =
            "<span class='navy--text text--lighten-3'>Round annullato</span>";
          break;
        // escludi / riammetti
        case Constants.LOG_TYPE.RIAMMISSIONE_ASTA:
          this.icon = "add";
          this.color = "grey lighten-3";
          this.testo = "L'admin ha riammesso " + ui.nomeSquadra + " all'asta";
          break;
        case Constants.LOG_TYPE.ESCLUSIONE_ASTA:
          this.icon = "close";
          this.color = "grey lighten-3";
          this.testo = "L'admin ha escluso " + ui.nomeSquadra + " dall'asta";
          break;
        case Constants.LOG_TYPE.ESCLUSIONE_ASTA_ADMIN:
          this.icon = "warning";
          this.color = "error";
          this.testo =
            "L'admin si è auto-escluso dall'asta. <span class='error--text'>Anche se escluso dall'asta dovrà comunque rimanere online per consentire agli altri partecipanti di proseguire l'asta</span>";
          break;
        // allineamento rose
        case Constants.LOG_TYPE.ALLINEA_ROSE_START:
          this.icon = "sync";
          this.color = "grey lighten-3";
          this.testo =
            "<span class='navy--text text--lighten-3'>Inizio allineamento rose</span>";
          break;
        case Constants.LOG_TYPE.ALLINEA_ROSE_SKIP:
          this.icon = "sync";
          this.color = "red lighten-3";
          this.testo =
            ui.nomeSquadra +
            ": crediti insufficienti per " +
            ui.nomeCalciatore +
            " (" +
            ui.prezzo +
            ") ";
          break;
        case Constants.LOG_TYPE.ALLINEA_ROSE_END:
          this.icon = "sync";
          this.color = "grey lighten-3";
          this.testo =
            "<span class='navy--text text--lighten-3'>Fine allineamento rose</span>";
          break;
        case Constants.LOG_TYPE.ALLINEA_ROSE_ERROR:
          this.icon = "sync";
          this.color = "red";
          this.testo =
            "<span class='navy--text text--lighten-3'>Errore in allineamento rose</span>";
          break;
        case Constants.LOG_TYPE.ROSE_IMPORTED:
          this.icon = "sync";
          this.color = "grey lighten-3";
          this.testo =
            "<span class='navy--text text--lighten-3'>Rose sovrascritte e assegnazioni annullate</span>";
          break;
        case Constants.LOG_TYPE.ROSE_EXPORTED:
          this.icon = "save";
          this.color = "grey lighten-3";
          this.testo =
            "<span class='navy--text text--lighten-3'>Rose salvate</span>";
          break;
      }
    },
  },
  computed: {
    effect() {
      return {
        "zoom-in-zoom-out":
          this.hasEffect && this.log.type == Constants.LOG_TYPE.ASSIGN,
      };
    },
    ...Vuex.mapGetters(["calciatori", "asta_squadre"]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
.asta-log {
  display: flex;
  justify-content: flex-start;
}
</style>
